if (!customElements.get('fp-seconda-maglietta')) {
  let fpTurnoControllo = 0;
  let fpTurnoPiede = 0;
  let fpTurnoCassetto = 0;
  let fpUltimaModifica = 0;
  let fpBlocco = null;
  let fpInviando = null;
  let fpScrittureIniziate = 0;
  const fpScritture = new Set();
  const fpPassa = new WeakSet();

  const fpSuCart = () => !!document.getElementById('main-cart-items');

  const fpLeggiFirma = () =>
    fetch(`${routes.cart_url}.js`, { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then((response) => {
        if (!response.ok) throw new Error(`cart.js ${response.status}`);
        return response.json();
      })
      .then((carrello) => carrello.items.map((riga) => `${riga.key}:${riga.quantity}`).join(','));

  const fpAggiornaPiede = () => {
    const piede = document.getElementById('main-cart-footer');
    if (!piede || !piede.dataset.id) return;
    const turno = (fpTurnoPiede += 1);

    return fetch(`${routes.cart_url}?section_id=${piede.dataset.id}`)
      .then((response) => response.text())
      .then((responseText) => {
        const nuovo = new DOMParser().parseFromString(responseText, 'text/html').querySelector('.js-contents');
        const vecchio = document.querySelector('#main-cart-footer .js-contents');
        if (turno === fpTurnoPiede && nuovo && vecchio) vecchio.innerHTML = nuovo.innerHTML;
      })
      .catch(() => {});
  };

  const fpRidisegnaCassetto = () => {
    const turno = (fpTurnoCassetto += 1);
    const leggi = (sezione) =>
      fetch(`${routes.cart_url}?section_id=${sezione}`)
        .then((response) => (response.ok ? response.text() : null))
        .catch(() => null);
    const bolla = document.getElementById('cart-icon-bubble') ? leggi('cart-icon-bubble') : null;

    return Promise.all([leggi('cart-drawer'), bolla]).then(([cassetto, icona]) => {
      if (turno !== fpTurnoCassetto) return;
      if (cassetto) {
        const html = new DOMParser().parseFromString(cassetto, 'text/html');
        ['cart-drawer-items', '.cart-drawer__footer'].forEach((selettore) => {
          const vecchio = document.querySelector(selettore);
          const nuovo = html.querySelector(selettore);
          if (vecchio && nuovo) vecchio.replaceWith(nuovo);
        });
      }
      const nuova = icona ? new DOMParser().parseFromString(icona, 'text/html').querySelector('.shopify-section') : null;
      const vecchia = document.getElementById('cart-icon-bubble');
      if (nuova && vecchia) vecchia.innerHTML = nuova.innerHTML;
    });
  };

  const fpAttivo = () => !!fpBlocco && Date.now() < fpBlocco.fino;

  const fpScrittureInCorso = () => {
    const adesso = Date.now();
    let quante = 0;
    fpScritture.forEach((voce) => {
      if (voce.fino > adesso) quante += 1;
    });
    return quante;
  };

  const fpOccupato = () => fpAttivo() || fpScrittureInCorso() > 0;

  const fpLiberaBottoni = () => {
    document.querySelectorAll('.fp-seconda__bottone[data-fp-bloccato]').forEach((bottone) => {
      bottone.removeAttribute('data-fp-bloccato');
      bottone.removeAttribute('data-fp-da-sbloccare');
      bottone.removeAttribute('aria-disabled');
      bottone.classList.remove('loading');
      const rotella = bottone.querySelector('.loading__spinner');
      if (rotella) rotella.classList.add('hidden');
    });
  };

  const fpMostraBlocco = () => {
    if (!fpOccupato()) return;
    const giro = fpAttivo() ? fpBlocco : null;
    document.querySelectorAll('.fp-seconda').forEach((riquadro) => {
      const stesso = !!giro && riquadro.classList.contains(`fp-seconda--${giro.contesto}`);
      riquadro.querySelectorAll('button.fp-seconda__bottone').forEach((bottone) => {
        if (bottone.hasAttribute('data-fp-bloccato')) return;
        bottone.setAttribute('data-fp-bloccato', '');
        bottone.setAttribute('aria-disabled', 'true');
        const campo = bottone.form ? bottone.form.querySelector('[name="id"]') : null;
        if (!stesso || !campo || campo.value !== giro.variante) return;
        bottone.classList.add('loading');
        const rotella = bottone.querySelector('.loading__spinner');
        if (rotella) rotella.classList.remove('hidden');
      });
    });
  };

  const fpOsservatore =
    typeof MutationObserver === 'function'
      ? new MutationObserver(() => {
          if (fpOccupato()) fpMostraBlocco();
          else fpOsservatore.disconnect();
        })
      : null;

  const fpAggiornaBlocco = () => {
    if (!fpOccupato()) {
      if (fpOsservatore) fpOsservatore.disconnect();
      fpLiberaBottoni();
      return;
    }
    fpMostraBlocco();
    if (fpOsservatore) fpOsservatore.observe(document.documentElement, { childList: true, subtree: true });
  };

  const fpChiudiGiro = (giro) => {
    if (!fpBlocco || (giro && fpBlocco !== giro)) return false;
    clearTimeout(fpBlocco.timer);
    fpBlocco = null;
    return true;
  };

  const fpSblocca = (giro) => {
    if (!fpChiudiGiro(giro)) return;
    fpLiberaBottoni();
    fpAggiornaBlocco();
  };

  const fpBlocca = (contesto, variante) => {
    fpChiudiGiro();
    fpLiberaBottoni();
    const giro = { contesto, variante, inviata: false, fino: Date.now() + 15000, scritture: fpScrittureIniziate, modifica: fpUltimaModifica };
    giro.timer = setTimeout(() => fpSblocca(giro), 15000);
    fpBlocco = giro;
    fpAggiornaBlocco();
    return giro;
  };

  const fpAccorcia = (giro) => {
    const fino = Date.now() + 5000;
    if (fpBlocco !== giro || fino >= giro.fino) return;
    giro.fino = fino;
    clearTimeout(giro.timer);
    giro.timer = setTimeout(() => fpSblocca(giro), 5000);
  };

  const fpScritturaCarrello = (risorsa, opzioni) => {
    const richiesta = typeof Request === 'function' && risorsa instanceof Request ? risorsa : null;
    const metodo = String((opzioni && opzioni.method) || (richiesta ? richiesta.method : 'GET')).toUpperCase();
    if (metodo !== 'POST') return false;
    const indirizzo = new URL(richiesta ? richiesta.url : String(risorsa), window.location.href);
    return /\/cart\/(add|change|update|clear)(\.js|\.json)?\/?$/.test(indirizzo.pathname);
  };

  const fpSegnaScrittura = (risposta) => {
    const voce = { fino: Date.now() + 15000, giro: fpInviando };
    let finita = false;
    const fine = () => {
      if (finita) return;
      finita = true;
      clearTimeout(voce.timer);
      fpScritture.delete(voce);
      if (voce.giro) fpAccorcia(voce.giro);
      fpAggiornaBlocco();
    };
    voce.timer = setTimeout(fine, 15000);
    fpScritture.add(voce);
    fpScrittureIniziate += 1;
    Promise.resolve(risposta).then(fine, fine);
    fpAggiornaBlocco();
  };

  if (typeof window.fetch === 'function') {
    const fpFetch = window.fetch;
    window.fetch = function () {
      const risposta = fpFetch.apply(this, arguments);
      try {
        if (fpScritturaCarrello(arguments[0], arguments[1])) fpSegnaScrittura(risposta);
      } catch (e) {}
      return risposta;
    };
  }

  const fpRinnova = (giro) => {
    if (fpSuCart()) {
      window.location.reload();
      return;
    }
    const fine = () => fpSblocca(giro);
    fpRidisegnaCassetto().then(fine, fine);
  };

  const fpEquivalente = (contesto, firma, variante) => {
    for (const riquadro of document.querySelectorAll(`.fp-seconda--${contesto}[data-fp-righe]`)) {
      if (riquadro.dataset.fpRighe !== firma) continue;
      for (const campo of riquadro.querySelectorAll('[name="id"]')) {
        const bottone = campo.form ? campo.form.querySelector('button.fp-seconda__bottone') : null;
        if (campo.value === variante && bottone) return { form: campo.form, bottone };
      }
    }
    return null;
  };

  const fpInvia = (form, bottone, contesto, giro) => {
    if (contesto === 'drawer') bottone.removeAttribute('aria-disabled');
    if (typeof form.requestSubmit !== 'function' && contesto === 'pagina') {
      form.submit();
      return;
    }
    fpPassa.add(form);
    fpInviando = giro;
    try {
      if (typeof form.requestSubmit === 'function') form.requestSubmit(bottone);
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    } finally {
      fpInviando = null;
      fpPassa.delete(form);
    }
  };

  const fpFineAggiunta = (evento) => {
    if (!fpBlocco || !fpBlocco.inviata || !evento || evento.source !== 'product-form') return;
    if (String(evento.productVariantId) !== String(fpBlocco.variante)) return;
    fpSblocca(fpBlocco);
  };

  let fpTurnoRighe = 0;

  const fpRigheCoppia = () => [...document.querySelectorAll('[data-fp-coppia-tipo]')];

  const fpMostraRighe = (decidi) => {
    fpRigheCoppia().forEach((riga) => {
      const visibile = !!decidi(riga);
      riga.hidden = !visibile;
      riga.classList.toggle('hidden', !visibile);
    });
  };

  const fpConCodice = (carrello) =>
    (carrello.cart_level_discount_applications || []).some((sconto) => !!sconto && sconto.type === 'discount_code') ||
    carrello.items.some((articolo) =>
      (articolo.line_level_discount_allocations || []).some(
        (parte) => !!parte && !!parte.discount_application && parte.discount_application.type === 'discount_code'
      )
    );

  const fpRileggiRighe = () => {
    if (!fpRigheCoppia().length) return;
    const turno = (fpTurnoRighe += 1);
    const nascondi = () => {
      if (turno === fpTurnoRighe) fpMostraRighe(() => false);
    };
    try {
      fetch(`${routes.cart_url}.js`, { cache: 'no-store', headers: { Accept: 'application/json' } })
        .then((response) => {
          if (!response.ok) throw new Error(`cart.js ${response.status}`);
          return response.json();
        })
        .then((carrello) => {
          if (turno !== fpTurnoRighe) return;
          const codice = fpConCodice(carrello);
          fpMostraRighe((riga) => {
            const magliette = carrello.items.reduce(
              (somma, articolo) => (articolo.product_type === riga.dataset.fpCoppiaTipo ? somma + articolo.quantity : somma),
              0
            );
            return !codice && carrello.currency === riga.dataset.fpCoppiaValuta && (magliette === 0 || magliette % 2 === 1);
          });
        })
        .catch(nascondi);
    } catch (e) {
      nascondi();
    }
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, fpFineAggiunta);
    subscribe(PUB_SUB_EVENTS.cartError, fpFineAggiunta);
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      fpRileggiRighe();
    });
  }

  customElements.define(
    'fp-seconda-maglietta',
    class FpSecondaMaglietta extends HTMLElement {
      cartUpdateUnsubscriber = undefined;

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source !== 'cart-items') {
            fpAggiornaPiede();
            return this.aggiorna(event.cartData);
          }
          const piede = document.getElementById('main-cart-footer');
          const sezioni = (event.cartData && event.cartData.sections) || {};
          if (piede && sezioni[piede.dataset.id]) fpTurnoPiede += 1;
          return this.aggiorna(event.cartData);
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      aggiorna(cartData) {
        const turno = (this.turno = (this.turno || 0) + 1);

        return Promise.resolve()
          .then(() => {
            const sezione = document.getElementById('main-cart-items').dataset.id;
            const html = cartData && cartData.sections && cartData.sections[sezione];
            if (html) {
              fpRidisegnaCassetto();
              return html;
            }
            return fetch(`${routes.cart_url}?section_id=${sezione}`).then((response) => response.text());
          })
          .then((responseText) => {
            if (turno !== this.turno) return;
            const nuovo = new DOMParser().parseFromString(responseText, 'text/html').querySelector('fp-seconda-maglietta');
            this.innerHTML = nuovo ? nuovo.innerHTML : '';
          })
          .catch(() => {
            if (turno === this.turno) this.innerHTML = '';
          });
      }
    }
  );

  const fpControllaRiquadri = () => {
    const riquadri = [...document.querySelectorAll('.fp-seconda[data-fp-righe]')];
    if (!riquadri.length) return;

    const turno = (fpTurnoControllo += 1);
    riquadri.forEach((riquadro) => riquadro.setAttribute('data-fp-verifica', ''));

    const libera = () => {
      if (turno !== fpTurnoControllo) return;
      document.querySelectorAll('.fp-seconda[data-fp-verifica]').forEach((riquadro) => riquadro.removeAttribute('data-fp-verifica'));
      if (fpOccupato()) return;
      document.querySelectorAll('.fp-seconda__bottone[data-fp-da-sbloccare]').forEach((bottone) => {
        bottone.removeAttribute('data-fp-da-sbloccare');
        bottone.removeAttribute('data-fp-bloccato');
        bottone.removeAttribute('aria-disabled');
        bottone.classList.remove('loading');
        const rotella = bottone.querySelector('.loading__spinner');
        if (rotella) rotella.classList.add('hidden');
      });
    };
    const scadenza = setTimeout(libera, 4000);

    fpLeggiFirma()
      .then((righe) => {
        clearTimeout(scadenza);
        const attuali = [...document.querySelectorAll('.fp-seconda[data-fp-righe]')];
        if (!attuali.some((riquadro) => riquadro.dataset.fpRighe !== righe)) return libera();
        if (fpSuCart()) return window.location.reload();
        return fpRidisegnaCassetto().then(libera);
      })
      .catch(() => {
        clearTimeout(scadenza);
        libera();
      });
  };

  const fpTipoNavigazione = () => {
    try {
      return performance.getEntriesByType('navigation')[0].type;
    } catch (e) {
      return '';
    }
  };

  const fpTornataIndietro = () => fpTipoNavigazione() === 'back_forward';

  const fpListaCambiata = () => {
    const riquadro = document.querySelector('fp-seconda-maglietta .fp-seconda[data-fp-righe]');
    if (!riquadro) return false;
    const attese = riquadro.dataset.fpRighe.split(',').filter(Boolean).map((riga) => riga.split(':').pop());
    const viste = [...document.querySelectorAll('#main-cart-items .cart-item')].map((riga) => {
      const quantita = riga.querySelector('[name="updates[]"]');
      return quantita ? quantita.getAttribute('value') : '';
    });
    return attese.join(',') !== viste.join(',');
  };

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') return;
    fpControllaRiquadri();
    fpRileggiRighe();
  });

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      if (fpBlocco && fpBlocco.contesto === 'pagina') fpChiudiGiro();
      document.querySelectorAll('.fp-seconda__bottone[data-fp-bloccato]').forEach((bottone) => {
        bottone.setAttribute('data-fp-da-sbloccare', '');
      });
    }
    if (!event.persisted && !fpTornataIndietro()) return;
    fpControllaRiquadri();
    fpRileggiRighe();
  });

  document.addEventListener(
    'change',
    (event) => {
      if (event.target instanceof Element && event.target.matches('cart-items [name="updates[]"], cart-drawer-items [name="updates[]"]')) {
        fpUltimaModifica = Date.now();
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      const riquadro = form instanceof Element ? form.closest('.fp-seconda') : null;
      if (!riquadro) return;
      if (fpPassa.has(form)) {
        fpPassa.delete(form);
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      const attesa = (typeof ON_CHANGE_DEBOUNCE_TIMER === 'number' ? ON_CHANGE_DEBOUNCE_TIMER : 300) + 200;
      if (
        fpOccupato() ||
        riquadro.hasAttribute('data-fp-verifica') ||
        document.querySelector('.cart__items--disabled') ||
        Date.now() - fpUltimaModifica < attesa
      ) {
        return;
      }

      const campo = form.querySelector('[name="id"]');
      const bottone = event.submitter && form.contains(event.submitter) ? event.submitter : form.querySelector('button.fp-seconda__bottone');
      if (!campo || !bottone) return;
      const firma = riquadro.getAttribute('data-fp-righe');
      const contesto = riquadro.classList.contains('fp-seconda--pagina') ? 'pagina' : 'drawer';
      const variante = campo.value;
      const giro = fpBlocca(contesto, variante);
      const concorrente = () =>
        fpScrittureIniziate !== giro.scritture || fpUltimaModifica !== giro.modifica || fpScrittureInCorso() > 0;

      fpLeggiFirma()
        .then((righe) => {
          if (fpBlocco !== giro) return;
          if (concorrente()) {
            fpSblocca(giro);
            return;
          }
          if (firma === null || righe !== firma) throw new Error('carrello cambiato');
          const bersaglio = form.isConnected ? { form, bottone } : fpEquivalente(contesto, firma, variante);
          if (!bersaglio) throw new Error('riquadro ridisegnato');
          giro.inviata = true;
          fpInvia(bersaglio.form, bersaglio.bottone, contesto, giro);
        })
        .catch(() => {
          if (fpBlocco !== giro || giro.inviata) return;
          if (concorrente()) fpSblocca(giro);
          else fpRinnova(giro);
        });
    },
    true
  );

  if (fpTipoNavigazione() === 'navigate' && fpListaCambiata()) window.location.reload();
}
